import { render } from "./Liabilities.vue?vue&type=template&id=027f969f&scoped=true"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"

import "./Liabilities.vue?vue&type=style&index=0&id=027f969f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027f969f"]])

export default __exports__